import { Icon24PublishedCommunity } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const PublishedCommunityIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        fill="currentColor"
        d="M16.523 9.21a1 1 0 0 1 1.477.88v1.167a4.5 4.5 0 0 0-1-.229v-.938l-5.001 2.707v4.863l.433-.235q.217.458.528.851l-1.223.663a.5.5 0 0 1-.476 0l-5.476-2.965A1.5 1.5 0 0 1 5 14.654V10.09a1 1 0 0 1 1.477-.88l5.023 2.72zM16.5 12a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M6 14.654a.5.5 0 0 0 .262.44l4.737 2.566v-4.863L6 10.09zm11.053-.378a.5.5 0 0 1 .894.448l-1 2a.5.5 0 0 1-.8.13l-1-1a.5.5 0 1 1 .707-.707l.508.508zM11.5 5a2.5 2.5 0 1 1-.002 5.002A2.5 2.5 0 0 1 11.501 5m0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
      />
    </svg>
  );
};

export const PublishedCommunityIcon = fplIcon(PublishedCommunityIconLocal, Icon24PublishedCommunity);
